export default {
    title: 'Delfinariu Constanta',
    search: 'Search',
    all_states: 'All States',
    all_museums: 'Our museums',
    homepage_title: "Delfinariu Constanta",
    homepage_desc: "Welcome! This is the official ticketing page for Delfinariu Constanta",
    cart: 'Cart',
    no_tickets: 'No tickets',
    no_instances_available_for_date: 'There are no tickets available for the selected date.',
    checkout: 'Checkout',
    ticket: 'ticket',
    next_step: 'Next',
    select_tickets: 'Select tickets',
    read_more: 'Show more',
    read_less: 'Show less',
    museums: 'Museums',
    login: 'Login',
    my_account: 'My account',
    register: 'Register',
    create_account: 'Create account',
    create_account_desc:'for easy access to your purchases history',
    continue_as_guest: 'Continue as guest',
    email: 'Email',
    phone: 'Phone',
    firstName: 'Firstname',
    lastName: 'Lastname',
    password: 'Password',
    confirm_password: 'Confirm password',
    accept_newsletter: 'I want to subscribe to the newsletter',
    send_sms: 'Also receive tickets via sms',
    terms_conditions: 'terms and conditions',
    authentication: 'Authentication',
    use_form_below: 'Use the form below to log in and access your tickets',
    forgot_password: 'I forgot my password',
    new_account: 'New Account',
    new_user: 'New client',
    enter_email_to_reset_password: 'Enter the email address of the account to reset the password',
    reset_password_button: 'Reset password',
    follow_email_instructions: 'Follow the instructions sent to your email to reset your password.',
    terms_and_conditions: 'Terms and Conditions',
    terms_intro: 'By purchasing a ticket through delfinariu.bilet.ro, you agree to the following terms and conditions, which you are obliged to comply with:',
    terms_detail_1: 'The ticket cannot be exchanged or refunded regardless of the reason invoked',
    terms_detail_2: 'If there are suspicions that you are using the website delfinariu.bilet.ro for malicious and/or abusive purposes, such as—but not limited to—repeatedly blocking seats without completing the order, creating multiple accounts and using them for purposes other than purchasing tickets, carrying out actions that could excessively load or stress the delfinariu.bilet.ro website, in such cases delfinariu.bilet.ro may temporarily suspend your account or, in exceptional cases, close it permanently. delfinariu.bilet.ro will not be required to notify you of the decisions taken nor to provide explanations, and these decisions may be permanent. Furthermore, delfinariu.bilet.ro reserves the right to notify the competent authorities regarding your actions.',
    terms_detail_3: 'Purchasing the ticket implies that you agree with the terms and conditions imposed by Delfinariu Constanta, regardless of the way they are displayed or communicated, and you undertake to comply with them. It is also your responsibility to familiarize yourself with them and to address any questions directly to Delfinariu Constanta in case of uncertainties.',
    terms_detail_4: 'delfinariu.bilet.ro charges a processing fee as well as a ticket delivery fee via SMS, which you agree to pay; these fees cover the costs required to process your order under optimal conditions and the cost of sending the SMS containing your purchased tickets.',
    terms_detail_5: 'delfinariu.bilet.ro is not responsible for actions unrelated to the ticket sales procedure.',
    terms_detail_6: 'If the tickets purchased from delfinariu.bilet.ro are resold or transferred for the purpose of obtaining material benefits by a third party unauthorized by delfinariu.bilet.ro, Delfinariu Constanta, the agents responsible for supervising the venue, as well as representatives of delfinariu.bilet.ro, may refuse entry to the ticket holders into Delfinariu Constanta, including their removal from the venue.',
    terms_detail_7: 'Unless otherwise specified, the ticket is valid for the entry of a single person on the date and within the time slot indicated on the ticket.',
    terms_detail_8: 'Delfinariu Constanta has the right to modify the date and time slot, with the new information being communicated through specific means.',
    terms_detail_9: 'Please make sure you arrive on time so that you can enter the venue during the time slot indicated on the ticket. Delfinariu Constanta reserves the right to deny entry if you arrive before or after the date and time slot indicated on the ticket.',
    terms_detail_10: 'This ticket may not be used as a prize in any competition without the prior consent of Delfinariu Constanta.',
    terms_detail_11: 'delfinariu.bilet.ro is not responsible for damages caused by third parties to any ticket holder who purchased through delfinariu.bilet.ro.',
    terms_detail_12: 'Entry to Delfinariu Constanta with alcoholic beverages, drugs, dangerous substances, blunt objects, and weapons of any kind is prohibited; ticket holders may be checked upon entry to ensure compliance with the announced rules.',
    terms_detail_13: 'The use of drugs or other illegal substances in Delfinariu Constanta constitutes a criminal offense and will be punished in accordance with applicable legal provisions.',
    terms_detail_14: 'Purchasing the ticket implies that you agree with the terms and conditions displayed on the delfinariu.bilet.ro website, as well as with the <a href="https://www.delfinariu.ro/regulament-de-vizitare/" target="_blank"><b>Visiting Regulations</b></a> displayed on delfinariu.ro, terms, conditions, and regulations, which you undertake to comply with.',
    response_payment: 'Payment response',
    payment_confirmed_congratulations: 'Payment has been confirmed. Congratulations!',
    open_e_ticket: 'Open E-TICKET',
    order_not_confirmed_error_message: 'Order could not be confirmed. Error message:',
    please_try_again_to_purchase_tickets: 'Please try again to purchase tickets.',
    please_pay_again_tickets: 'Please try again to make the payment. Your tickets are on hold until',
    museum_list: 'List of museums',
    back: 'Back',
    orders: 'Orders',
    personal_info: 'Personal information',
    change_password: 'Change password',
    exit: 'Exit',
    no_orders: 'No orders',
    save: 'Save',
    current_password: 'Current password',
    new_password: 'New password',
    delete: 'Delete',
    tickets_total: 'Tickes total',
    tax: 'Processing fees',
    total_payment: 'To pay',
    pay: 'Go to payment',
    pay_again: 'Pay again',
    continue_shopping: 'Select more tickets',
    cookie_message: 'We use cookies to improve your experience on our website. By continuing to browse, you agree to our privacy policy.',
    cookie_accept: 'Accept',
    cookie_learn_more: 'GDPR Policy',
    tickets_email: 'We will send the tickets to this email address',
    modify: 'Modify',
    my_cart: 'My tickets',
    user_details: 'Client details',
    payment: 'Payment',
    terms: 'Terms and conditions',
    gdpr: 'GDPR terms',
    last_tickets: 'Last tickets',
    sold_out: 'Sold Out',
    pick_tickets: 'Choose tickets',
    not_found_order: 'Order not found',
    expiration_date: 'Expiration date',
    open_eticket: 'Open E-TICKET',
    payment_method: 'Payment',
    delivery_method: 'Delivery',
    show_details: 'show details',
    hide_details: 'hide details',
    Confirmat: 'Confirmed',
    Neconfirmat: 'Pending',
    Anulat: 'Canceled',
    tickets: 'Tickets',
    my_order: 'My order',
    what_to_visit: 'Our Attractions',
    'TARIF INTREG': 'FULL PRICE',
    'TARIF ELEV/STUDENT': 'STUDENT PRICE',
    'GRATUIT': 'FREE',
    Adult: 'Adult',
    Elev: 'Elev',
    Student: 'Student',
    Pensionar: 'Pensionar',
    Delfinariu: 'Dolphinarium',
    Planetariu: 'Planetarium',
    Microrezervatie: 'Micro Zoo',
    Parcare: 'Parking',
    DELFINARIU: 'DOLPHINARIUM',
    PLANETARIU: 'PLANETARIUM',
    MICROREZERVATIE: 'MICRO ZOO',
    PARCARE: 'PARKING',
    go_to_schedule: 'Check Visiting Schedule',
    faqs: 'FAQs',
    easter_schedule: 'Easter Holidays Schedule',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    tickets_desk_close: 'The ticket desk closes at 13:00.',
    closed: 'CLOSED',
    last_enter: 'last entry',
    last_enter_optional: 'last entry optional tour 12:30',
    school_children: 'School children benefit from free admission during school holidays.',
    under7: 'Children up to 7 years old – free of charge.',
    invoice: 'Invoice',
    invoice_info: 'If you want an invoice for your order on delfinariu.bilet.ro, please fill out the form below carefully.',
    transaction_id: 'Order number',
    email_address: 'E-mail address',
    visit_date: 'Date of visit',
    full_name: 'Full name',
    company_name: 'Company',
    cui: 'Tax ID number',
    reg_com: 'Business register number',
    address: 'Registered office/Address',
    bank: 'Bank',
    iban: 'Account (IBAN)',
    invoice_type: 'Invoice type',
    country: 'Country',
    company_representative: 'Company representative',
    company: 'Company',
    individual: 'Individual',
    barcode: 'Barcode of a ticket',
    barcode_invoice_info: 'for prooving the ownership of the order',
    email_address_invoice_info: 'email address for sending the invoice',
    invoice_aggree: 'I consent to Delfinariu Constanta using the personal information provided in this form (name and surname, e-mail address, bank account information), in accordance with EU Regulation 2016/679 - Protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC (General Data Protection Regulation) and other applicable legislation, with the purpose of issuing the invoice.',
    invoice_send: 'Send',
    invoice_request_ok: 'Your invoice request has been succesfully sent.',
    invoice_generated_ok: 'Your invoice was successfully generated and sent to the email address provided.',
    invoice_request_error: 'Your invoice request could not be sent. Please verify the order number and the barcode.',
    invoice_already_printed: 'Invoice already generated',
    invalid_cui: 'Invalid Tax ID number',
    refund_policy: 'Return Policy',
    refund_detail_2: 'Online tickets purchased on delfinariu.bilet.ro before 23.05.2025 are valid for 14 days. If the 14-day period has been exceeded without using the ticket, the value of the ticket is not refunded.',
    refund_detail_1: 'Tickets for visiting Delfinariu Constanta are sold with timed reservations and are non-refundable.',
    refund_title: 'Ticket refund request',
    refund_aggree: 'I consent to Delfinariu Constanta using the personal information provided in this form (name and surname, e-mail address, bank account information), in accordance with EU Regulation 2016/679 - Protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC (General Data Protection Regulation) and other applicable legislation, with the purpose of processing the refund request.',
    ticket_identificator: 'Ticket series/order ID/Date of purchase',
    refund_info: 'The money will be refunded to the account from which you made the payment. The cost of the tickets will be refunded, but not the transaction processing fee.',
    refund_bank_details: 'Bank account information (name, surname, bank, IBAN code)',
    refund_reason: 'Reason you want a refund',
    refund_request_ok: 'Your refund request was succesfully sent.',
    refund_request_error: 'There was an error in sending your request. Please verify the order number',
    contact_technical: 'Technical ticketing info',
    contact_museum: 'Info about visiting the museum',
    confirm_hour_add_title: 'Atention!',
    confirm_hour_add_msg: 'The castle is closed for today!',
    add_to_cart: 'Add to cart',
    mandatory_field: 'This field is mandatory.',
    wrong_email: 'Invalid email format.',
    password_mismatch: 'Password mismatch.',
    terms_mandatory: 'Please accept terms and conditions.',
    phone_invalid: 'Phone number is not valid.',
    hour: 'Hour',
    access_interval: 'Entrance interval',
    select_date: 'Select visiting date',
    selected_date_label: 'Selected date',
    extra_section_eyebrow: 'Recommended together',
    extra_events_subheading: 'Buy tickets also for:',
    select_access_interval: 'Select entrance interval',
    info_fewer_tickets: 'Fewer tickets were selected than wanted',
    could_not_select_all: 'Fewer tickets selected',
    info_no_tickets: 'There are no more tickets available',
    could_not_select: 'Error selecting tickets',
    free_seat_info: 'The transaction must include at least one paid ticket. To purchase more than 3 free tickets, please go to the ticket office located inside Pelișor Castle.',
    non_refundable_condition: 'I acknowledge that the ticket cannot be used outside the day and time slot for which it was purchased, and its value is non-refundable regardless of the reason given.',
    'Accesul fizic în muzeu se face în baza documentelor justificative (carte de identitate, talon pensie, pașaport)': 'Physical access to the museum is based on supporting documents (identity card, pension slip, passport)',
    'Accesul în muzeu se face pe baza documentelor justificative (carnet de elev)': 'Access to the museum is based on supporting documents (student ID)',
    'Accesul fizic în muzeu se face pe baza documentelor justificative (carnet de student)': 'Physical access to the museum is based on supporting documents (student ID)',
    'Accesul fizic în muzeu se face în baza documentelor justificative (card Euro 26, carte de identitate, pașaport)': 'Physical access to the museum is based on supporting documents (Euro 26 card, identity card, passport)',
    'Atentie: Pentru copii sub 7 ani sau elevi in timpul vacantelor scolare': 'Attention: For children under 7 years or school children during school holidays',
    today: 'Today',
    tomorrow: 'Tomorrow',
    empty_cart: 'Your cart is empty',
    group_tickets: 'Group tickets',
    quantity: 'No. tickets',
    ticket_type: 'Ticket type',
    discount: 'Discount',
    price: 'Price',
    group_tickets_info: 'Group to scan the same QR code for identical tickets (same date, time, price, and discount).',
    parking_details: 'Parking details',
    parking_details_info: 'Car access to the parking lot is based on license plate recognition. Please enter your license plate number(s) carefully:',
    licence_plate: 'Licence plate',
    licence_plate_required: 'Please enter the licence plate.',
    licence_plate_min_length: 'The licence plate must contain at least 3 characters.'
}
